import classnames from 'classnames';

import Icon from '~/components/icon';
import Link from '~/components/link';
import INavigationLink from '../../../../../../interfaces/navigation-link';

import styles from './featured-sports.module.css';

interface IProps {
  featuredSports: INavigationLink[];
}

function maxIconDimension(name: string, dimension: number): number {
  const maxDimension = (() => {
    switch (name) {
      case 'Offers':
      case 'Politics':
      case 'Casino':
        return 14;

      case 'Hockey':
      case 'MotorSport':
        return 16;

      case 'Cycling':
        return 26;

      case 'AmericanFootball':
      case 'BasketBall':
      case 'Baseball':
      case 'Golf':
      case 'Boxing':
      case 'Football':
      case 'Tennis':
      case 'RugbyLeave':
      case 'Awards':
      case 'Specials':
      case 'Darts':
        return 22;
    }
  })();

  return maxDimension || dimension;
}

function Sports({ featuredSports }: IProps): JSX.Element | null {
  if (!featuredSports?.length) {
    return null;
  }

  return (
    <div data-testid="featured-sports" className={styles.sports}>
			{featuredSports.map(({ url, text, isSelected, icon = '' }) => {
        const [iconName, iconDimension = '22'] = icon.split(',');
        const dimension = maxIconDimension(
          iconName,
          parseInt(iconDimension, 10)
        );

        return (
          <Link
            className={classnames(
              styles.sport,
              isSelected ? styles.selected : ''
            )}
            to={url}
            key={url}>

						<Icon
              icon={iconName}
              className={styles.icon}
              height={dimension}
              width={dimension} />

						{text}
					</Link>);

      })}
		</div>);

}

export default Sports;